import { render, staticRenderFns } from "./TrainingsPage.vue?vue&type=template&id=750b82d6&scoped=true"
import script from "./TrainingsPage.vue?vue&type=script&lang=js"
export * from "./TrainingsPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingsPage.vue?vue&type=style&index=0&id=750b82d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b82d6",
  null
  
)

export default component.exports